import React from "react";
import { CMS_SHOW_FIELD_KEYS } from "../constants";
import { formatFieldKey } from "../utils/cmsLabels";
import CmsKeyChip from "./CmsKeyChip";

function CmsFieldKey({ fieldKey }) {
  if (!fieldKey || !CMS_SHOW_FIELD_KEYS) return null;

  return (
    <CmsKeyChip
      value={fieldKey}
      title={formatFieldKey(fieldKey)}
      variant="field"
    />
  );
}

export default CmsFieldKey;
